"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;

var _baseui = require("baseui");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Content = (0, _baseui.styled)('div', function (_ref) {
  var $theme = _ref.$theme;
  var sizing = $theme.sizing;
  return _defineProperty({
    paddingTop: sizing.scale800,
    paddingLeft: sizing.scale800,
    paddingRight: sizing.scale800
  }, "@media screen and (min-width: 850px)", {
    paddingLeft: sizing.scale1600,
    paddingRight: sizing.scale1600
  });
});
exports.Content = Content;